import { OrganisationStructureLevel } from 'const';
import { useNavigationContext } from 'hooks';
import { NavigationContext } from 'store';

type OrganisationStructureFilter = {
  required?: OrganisationStructureLevel;
  forbidden?: OrganisationStructureLevel;
};

type Props = {
  filters?: OrganisationStructureFilter[];
  children: React.ReactNode;
  fallbackComponent?: React.ReactNode;
};

export const OrganisationStructureContextFilter = ({
  filters = [],
  children,
  fallbackComponent = null,
  ...props
}: Props) => {
  const navigationContext = useNavigationContext();
  const hasRequiredContext = useContextRequirements(navigationContext, filters);

  if (hasRequiredContext) {
    return <div {...props}>{children}</div>;
  }

  return <div {...props}>{fallbackComponent}</div>;
};

const useContextRequirements = (
  navigationContext: NavigationContext,
  filters: OrganisationStructureFilter[]
) => {
  const stringifiedNavigationContext: string = JSON.stringify(navigationContext);
  return (
    !filters.length ||
    filters.some(
      ({ forbidden, required }) =>
        (!required || stringifiedNavigationContext.includes(required)) &&
        (!forbidden || !stringifiedNavigationContext.includes(forbidden))
    )
  );
};
